export default "__VITE_ASSET__DTyGuQMt__"